import { fetchDimensions } from '../service/dimensionService'
import { Dimension } from '../types/Dimension'
import dimensionQueryKeys from './dimensionQueryKeys'

export const getDimensionOptions = <TData = Dimension[]>(companyId?: string, select?: (data: Dimension[]) => TData) => {
  return {
    queryKey: dimensionQueryKeys.list({ companyId }),
    queryFn: fetchDimensions,
    gcTime: 15 * 60 * 1000,
    staleTime: 5 * 60 * 1000,
    enabled: !!companyId,
    select: (data: Dimension[]) => {
      // If a selector is provided, run it on the data
      if (select) {
        return select(data)
      }

      // Otherwise return the data as-is
      return data as TData
    }
  }
}
